import React, { useState } from 'react';
import { useTranslations, useGetTransactionDetails } from "examsbook-react-sdk/custom-hooks";
import { makeStyles, Button } from "@material-ui/core";
import SuccessImg from "../assets/images/success-transaction.svg";
import failureImg from "../assets/images/failure-transaction.svg";
import { useNavigate } from "react-router-dom";
import Payments from "./payments";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const useStyles = makeStyles({
    transactionContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        paddingTop: 15
    },
    imgContainer: {
        marginBottom: 20,
        '& img': {
            width: '100%'
        }
    },
    message: {
        '& h4': {
            fontSize: 28,
            textAlign: 'center',
            margin: 0,
            paddingBottom: 7,
            color: '#101010'
        },
        '& p': {
            fontSize: 18,
            margin: 0,
            paddingBottom: 20,
            color: '#101010',
            textAlign: "center"
        },
        '& button': {
            backgroundColor: '#008e76',
            color: '#fff',
            width: '100%',
            padding: '8px 14px',
            textTransform: 'capitalize',
            fontSize: 14,
            maxWidth: '240px',
            margin: '0 auto',
            display: 'block',
            '&:hover': {
                backgroundColor: '#008e76',
            }
        }
    },
    transactionDetails: {
        border: "1px solid #eee",
        padding: 30,
        borderRadius: 5,
        '& > div': {
            marginBottom: 15,
            display: 'flex',
            '& h5': {
                margin: 0,
                fontSize: 15,
                marginRight: 10,
                minWidth: 150
            },
            '&:last-child': {
                marginBottom: 0
            }
        },
        '@media (max-width:767px)': {
            padding: 20,
            backgroundColor: "#fff",
            '& > div': {
                '& span': {
                    wordBreak: 'break-all'
                }
            }
        }
    },
    dashboardButton: {
        backgroundColor: "#008e76",
        color: "white",
        textTransform: 'capitalize',
        padding: "8px 22px",
        '&:hover': {
            backgroundColor: '#008e76',
        },
    },
    goToDashboardBtn: {
        display: "flex",
        justifyContent: "center",
        marginTop: 30
    }
});

function PaymentResponse(props) {
    const navigate = useNavigate();
    const t = useTranslations();
    const { match } = props;
    const classes = useStyles();
    const transactionId = match.params.transactionId;
    const transaction = useGetTransactionDetails(transactionId);
    const [ showDetails, setShowDetails ] = useState(false);
    const showTransactionDetails = () => {
        setShowDetails(true);
    };

    function goToDashboard() {
        navigate('/my-app/');
    }

    function goToPayment() {
        navigate('/my-app/payments');
    }

    const transactionData = transaction ? transaction.data : {};
    return (
        <div>
            {
                !showDetails ?
                    <>
                        {
                            transactionData.status === "SUCCESS" ? <div className={classes.transactionContainer}>
                                <div className="mobile-back-to-test">
                                    <ArrowBackIcon onClick={goToDashboard}/>
                                    <span>{t('Checkout')}</span>
                                </div>
                                <div className={classes.imgContainer}>
                                    <img src={transactionData.status === 'SUCCESS' ? SuccessImg : failureImg} alt=""/>
                                </div>
                                <div className={classes.message}>
                                    <h4>{transactionData.status === 'SUCCESS' ? t("CONGRATULATIONS") : t("OPPS")}</h4>
                                    <p>{transactionData.status === 'SUCCESS' ? t("SUCCESS_TRANSACTION") : t("FAILURE_TRANSACTION")}<span></span>
                                    </p>
                                    {transactionData.status === 'SUCCESS' ?
                                        <Button onClick={showTransactionDetails}>{t("TRANSACTION_DETAILS")}</Button> :
                                        <Button onClick={goToPayment}>{t("RETRY_PAYMENT")}</Button>}
                                </div>
                            </div> : <Payments failed={true} transactionDetails={transactionData}/>
                        }
                    </>
                    :
                    transactionData ? <div>
                            <div className="mobile-back-to-test">
                                <ArrowBackIcon onClick={goToDashboard}/>
                                <span>{t('Checkout')}</span>
                            </div>
                            <div className={classes.transactionDetails}>
                                <div><h5>{t("TRANSACTION_ID")}</h5> <span>{transactionData.transId}</span></div>
                                <div><h5>{t("TRANSACTION_DATE")}</h5> <span>{transactionData.transDate}</span></div>
                                <div><h5>{t("ORDER_ID")}</h5><span>{transactionData.orderRefNo}</span></div>
                                <div><h5>{t("STATUS")}</h5><span>{transactionData.status}</span></div>
                                <div><h5>{t("PAID_AMOUNT")}</h5><span>{transactionData.paidAmt}</span></div>
                                <div><h5>{t("CURRENCY")}</h5><span>{transactionData.currency}</span></div>
                            </div>
                            <div className={classes.goToDashboardBtn}>
                                <Button className={classes.dashboardButton}
                                        onClick={goToDashboard}>{t("GO_TO_DASHBOARD")}</Button>
                            </div>
                        </div>
                        : <div></div>
            }
        </div>

    );
}

export default PaymentResponse;
